import React from 'react';

function CustomCard({ children, className }) {
  return (
    <div className={`card margin_bottom_40 ${className || ''}`}>{children}</div>
  );
}

export default CustomCard;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/CustomCard.jsx